var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-list',[_c('v-list-item',{on:{"click":_setup.switchUser}},[_c('v-list-item-icon',{staticClass:"ml-3"},[_c('img',{staticStyle:{"width":"22px"},attrs:{"src":require("./assets/2.svg"),"alt":"switch"}})]),_c('v-list-item-title',[_vm._v(" تسجيل الدخول بهذا الحساب")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }